<template>
  <v-container justify="center" class="white pa-2" fluid>
    <v-row dense class="header-wrapper justify-center ma-auto">
      <v-col align="center" col="4">
        <h1 class="black--text"></h1>
      </v-col>
      <v-col align="right" col="2">
        <v-btn @click="addFormModal = true" color="secondary" depressed>
          <v-icon class="mr-2">mdi-account-multiple-plus-outline</v-icon>
          add
        </v-btn>
      </v-col>
      <!-- TASK FORM MODAL -->
      <v-dialog v-model="addFormModal" persistent max-width="550">
        <TaskForm
          v-if="addFormModal"
          :epicId="id"
          :task="null"
          @closed="addFormModal = false"
        ></TaskForm>
      </v-dialog>
    </v-row>
    <v-divider light></v-divider>
    <v-row
      v-if="tasks.records"
      class="justify-center align-strech mt-3 kanban-view"
    >
      <v-col
        :id="lane.title"
        class="lane kanban-lane"
        v-for="lane in board"
        :key="lane.title"
        cols="12"
        sm="3"
        lg="3"
        md="3"
        :style="{ background: lane.color }"
      >
        <p class="lane-title">{{ lane.title }}</p>
        <draggable
          :component-data="getComponentData()"
          :v-model="lane.tasks"
          :animation="200"
          ghost-class="ghost-card"
          group="tasks"
        >
          <TaskCard
            v-for="tasks in lane.tasks"
            :key="tasks.id"
            :id="tasks.id"
            :task="tasks"
            :user="tasks.assignedTo"
            class="mt-3 cursor-move"
          ></TaskCard>
        </draggable>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import draggable from "vuedraggable";
import TaskCard from "../../../components/Base/Tasks/TaskCard";
import TaskForm from "../../../components/Base/Tasks/TaskForm";
import { gql } from "apollo-boost";

export default {
  name: "TaskStatusPage",
  components: {
    TaskCard,
    draggable,
    TaskForm,
  },
  data() {
    return {
      addFormModal: false,
      tasks: [],
      me: "",
    };
  },
  apollo: {
    me: gql`
      query {
        me {
          id
          firstName
          lastName
          role
        }
      }
    `,

    tasks: {
      query: gql`
        query Tasks($limit: Int!, $skip: Int!, $query: JSON!) {
          tasks(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              user
              assignedTo
              status
              description
              userName
              assignedToName
              createdAt
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        const self = this;
        const limit = 9999;
        const skip = 0;
        return {
          limit: limit,
          skip: skip,
          query: {},
        };
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
    },

    user: {
      query: gql`
        query User($id: ID!) {
          user(id: $id) {
            id
            firstName
            lastName
            title
            relationship
            gender
            race
            telNumber
            altNumber
            email
            businessEmail
            faxNumber
            bio
            rating
            age
            dob
            idNumber
            passport
            fullAddress
            language
            postalAddress
            industry
            role
            referral
            consultant
            consultantName
            postalCode
            region
            mailingPref
            companyName
            updatedBy
            updatedByName
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        this.isLoading = false;
        this.userModel.id = this.user.id;
        this.userModel.firstName = this.user.firstName;
        this.userModel.lastName = this.user.lastName;
        this.userModel.title = this.user.title;
        this.userModel.relationship = this.user.relationship;
        this.userModel.gender = this.user.gender;
        this.userModel.race = this.user.race;
        this.userModel.telNumber = this.user.telNumber;
        this.userModel.altNumber = this.user.altNumber;
        this.userModel.email = this.user.email;
        this.userModel.businessEmail = this.user.businessEmail;
        this.userModel.faxNumber = this.user.faxNumber;
        this.userModel.rating = this.user.rating;
        this.userModel.bio = this.user.bio;
        this.userModel.dob = this.user.dob;
        // years = this.user.age;
        this.userModel.age = this.user.age;
        this.userModel.idNumber = this.user.idNumber;
        this.userModel.passport = this.user.passport;
        this.userModel.fullAddress = this.user.fullAddress;
        this.userModel.postalAddress = this.user.postalAddress;
        this.userModel.language = this.user.language;
        this.userModel.industry = this.user.industry;
        this.userModel.role = this.user.role;
        this.userModel.referral = this.user.referral;
        this.userModel.consultant = this.user.consultant;
        this.userModel.consultantName = this.user.consultantName;
        this.userModel.postalCode = this.user.postalCode;
        this.userModel.region = this.user.region;
        this.userModel.mailingPref = this.user.mailingPref;
        this.userModel.companyName = this.user.companyName;
        this.userModel.updatedBy = this.user.updatedBy;
        this.userModel.updatedByName = this.user.updatedByName;
      },
    },
  },
  computed: {
    board() {
      return [
        { title: "To Do", tasks: this.toDo, color: "#f75959" }, //his.getRandomColors()
        { title: "In Progress", tasks: this.inProgress, color: "#f7b059" },
        {
          title: "Needs Reviewing",
          tasks: this.needsReviewing,
          color: "#59daf7",
        },
        { title: "Done", tasks: this.done, color: "#59f764" },
      ];
    },
    toDo() {
      return this.tasks.records.filter((item) => {
        return item.status === "ToDo";
      });
    },
    inProgress() {
      return this.tasks.records.filter((item) => {
        return item.status === "InProgress";
      });
    },
    needsReviewing() {
      return this.tasks.records.filter((item) => {
        return item.status === "NeedsReviewing";
      });
    },
    done() {
      return this.tasks.records.filter((item) => {
        return item.status === "Done";
      });
    },
  },
  methods: {
    getComponentData() {
      return {
        on: {
          add: this.draggableAdded,
        },
      };
    },
    handleChange(element) {},
    inputChanged(value) {},
    ended(element) {},
    draggableAdded(element) {
      const payload = {
        taskId: element.item.id,
        newStatus: element.to.parentElement.id.replace(/\s/g, ""), // Remove white space in status name (In Progress)
      };

      // Update DB with the new swim lane status
      this.updateTaskStatus(payload);

      // Trigger Email on Review Swim lane
      if (payload.newStatus === "NeedsReviewing") {
        this.sendEmail(payload);
      }
    },
    async updateTaskStatus(payload) {
      const self = this;
      try {
        const updateStatus = await self.$apollo.mutate({
          mutation: gql`
            mutation updateTask($task: TaskUpdateInput!) {
              updateTask(task: $task) {
                id
                updated
              }
            }
          `,
          variables: {
            task: {
              id: payload.taskId,
              status: payload.newStatus,
            },
          },
        });
        if (!updateStatus) {
          throw "Something went wrong when Updating the task!";
        }
        if (updateStatus.errors && updateStatus.errors.length > 0) {
          throw updateStatus.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async sendEmail(payload) {
      const self = this;
      self.isLoading = true;
      self.successMessage = "";
      self.errorMessage = "";
      try {
        const sendTaskEmail = await self.$apollo.mutate({
          mutation: gql`
            mutation ($id: ID!) {
              updateKanbanEmail(id: $id)
            }
          `,
          variables: {
            id: payload.taskId,
          },
        });
        if (sendTaskEmail) {
          self.successMessage = `Message sent`;
        }
        self.isLoading = false;
      } catch (error) {
        if (error.response) {
          self.errorMessage = `${error.response.data}`;
        } else self.errorMessage = `Message not sent: ${error.message}`;
        self.isLoading = false;
      }
    },
  },
  openTaskDescription() {
    this.taskDescModal = true;
  },
};
</script>

<style lang="scss" scoped>
.column-width {
  min-width: 320px;
  width: 320px;
}
.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.lane {
  min-width: 320px;
  width: 320px;
  padding: 0.75rem;
  border-radius: 0.5rem;
  margin: 4px;
  max-width: 400px;
  min-height: 1000px;
  .lane-title {
    color: #4e4444;
    font-weight: 500;
    font-size: 22px;
    text-decoration-line: underline;
  }
}

div#Needs\ Reviewing {
  background-color: #0a2752;
  .lane-title {
    color: #fff;
    font-weight: 500;
    font-size: 22px;
    text-decoration-line: underline;
  }
}
.kanban-view .lane.kanban-lane {
  width: 24%;
  max-width: 24%;
  min-width: 24%;
}

.card-wrapper .card-footer > div {
  display: inline-block;
  width: 50%;
  padding-right: 5px;
}

.card-wrapper .card-footer > div:nth-child(1) .mx-auto.text-right,
.card-wrapper .card-footer > div:nth-child(1) button {
  display: inline-block;
}

.kanban-view .lane.kanban-lane {
  overflow-y: auto;
  height: 100vh;
}

.card-wrapper .card-header .card-title {
  cursor: pointer;
  font-weight: 700;
  margin-left: 10px;
  font-size: 16px;
}
</style>
